import React, { useEffect, useState } from 'react'

import styled from "styled-components";

import { Form, FormInstance, notification, Select } from "antd";

import { txt } from "../../../../../locales/i18n";

import * as ExperienceService from '../../../../../services/bb-api/oplevalt/experience'

export type CarouselPanelProps = {
	propertyKey: string
	formRef: React.RefObject<FormInstance>
	onSectionChange: (changedValues: any, values: any) => void
}

export const CarouselPanel = (props: CarouselPanelProps) => {
	const [categories, setCategories] = useState<{ label: string, value: number }[]>([]);

	useEffect(() => {
		const getCategories = async () => {
			try {
				const categories = await ExperienceService.getCategories()
				const categoriesNormalized = categories.map((category) => ({ label: category.name, value: category.id }))
				setCategories(categoriesNormalized)
			} catch (e) {
				notification.error({ message: txt('oplevalt.notifications.unknown error') })
			}
		}

		getCategories()
	}, [])

	return (
		<CarouselPanelStyled>
			<label>{txt('cms.category')}</label>
			<Form.Item name={[props.propertyKey, 'category']}>
				<Select dropdownMatchSelectWidth={false} options={categories} loading={categories?.length === 0} />
			</Form.Item>
		</CarouselPanelStyled>
	)
}

const CarouselPanelStyled = styled.div`
	
`